module.exports = __webpack_public_path__ + "static/media/treatment-preview-signature.efb8d41c.png";